import React, { useEffect, useState } from "react";
import "../../../assets/AdminCss/admin_roles.css";
import AdminSidebar from "./AdminSidebar";
import AdminHeader from "./AdminHeader";
import { Link, useNavigate } from "react-router-dom";
// import '../../../assets/AdminCss/add_roles.css'
import { base_url } from "./AdminUsers";
import axios from "axios";

const AddSlider = () => {
  const navigate = useNavigate();
  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  // Toggle sidebar visibility
  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };
  const [formData, setFormData] = useState({
    title: '',
    status: 'Active',
    type: 'Web',
  });
  
  const [file, setFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value
    }));
  };
  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setFile(selectedFile);
      // Create a preview URL for the selected image
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewUrl(reader.result);
      };
      reader.readAsDataURL(selectedFile);
    }
  };

  const handleSubmit = async (e) => {
  

    e.preventDefault();
    
    const formDataToSend = new FormData();
    formDataToSend.append('title', formData.title);
    formDataToSend.append('status', formData.status);
    formDataToSend.append('type', formData.type);
    
    if (file) {
      formDataToSend.append('attachment', file);
    }

    try {
      const auth = localStorage.getItem('admin');
      const response = await axios.post(
        `${base_url}/api/webapi/addBanner`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `${auth}`,
          }
        }
      );
      
      // console.log('Response:', response);
      if (response.data.success) {
        navigate("/admin/slider");
        // Reset form
        setFormData({
          title: '',
          status: 'Active',
          type: 'Web',
        });
        setFile(null);
        setPreviewUrl('');
      }
    } catch (error) {
      console.error('Error adding slider:', error);
      alert('Failed to add slider. Please try again.');
    }
  };

  useEffect(() => {
      const handleResize = () => {
        const mobile = window.innerWidth < 768;
        setIsMobile(mobile);
        
        // On desktop, sidebar should always be "open"
        if (!mobile) {
          setIsSidebarOpen(true);
        }
      };
      
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);

  return (
    <div className="wrapper">
      {/* Main Sidebar */}
      <AdminSidebar 
          isSidebarOpen={isSidebarOpen} 
          toggleSidebar={toggleSidebar} 
          isMobile={isMobile}
        />
        
        {/* Header - Pass mobile info */}
        <AdminHeader 
          toggleSidebar={toggleSidebar} 
          isSidebarOpen={isSidebarOpen}
          isMobile={isMobile}
        />
        
        {/* Content Wrapper - Use conditional class and margin */}
        <div
          className={`content-wrapper ${
            !isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
          style={{
            marginLeft: (!isMobile && isSidebarOpen) ? "" : "0",
            transition: "margin-left 0.3s ease"
          }}
        >
        <div className="container-fluid">
          <h1 className="page-title custom_pagetitle">
            <i className="sidebar-mini-lock"></i> Add Slider
          </h1>
          <div id="sidebar-mini-notifications"></div>
          <div className="page-content mt-4 browse">
            <div className="alerts"></div>
            <div className="row">
              <div className="col-md-12 oneonofftab">
                <div className="panel panel-bordered p-3">
                  <div className="panel-body">
                    <div className="mt-3">
                      <form onSubmit={handleSubmit} encType="multipart/form-data">
                        <div className="d-flex flex-column gap-4">
                          <div>
                            <label htmlFor="title">Title</label>
                            <input
                              type="text"
                              className="form-control"
                              name="title"
                              id="title"
                              placeholder="Title"
                              value={formData.title}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div>
                            <label htmlFor="attachment">Attachment</label>
                            <input
                              type="file"
                              className="form-control"
                              accept="image/*"
                              name="attachment"
                              id="attachment"
                              onChange={handleFileChange}
                              required
                            />
                            {previewUrl && (
                              <div className="mt-2">
                                <p>Preview:</p>
                                <img
                                  src={previewUrl}
                                  alt="Preview"
                                  style={{ maxWidth: '200px', maxHeight: '200px' }}
                                />
                              </div>
                            )}
                          </div>

                          <div className="custom-select-wrapper">
                            <label htmlFor="status">Status</label>
                            <select
                              id="status"
                              className="form-control custom-select"
                              name="status"
                              onChange={handleChange}
                              value={formData.status}
                            >
                              <option value="Active">Active</option>
                              <option value="Inactive">InActive</option>
                            </select>
                            <i className="fa fa-chevron-down dropdown-icon mt-3"></i>
                          </div>

                          <div className="custom-select-wrapper">
                            <label htmlFor="type">Type</label>
                            <select
                              id="type"
                              className="form-control custom-select"
                              name="type"
                              onChange={handleChange}
                              value={formData.type}
                            >
                              <option value="Web">Web</option>
                              <option value="Phone">Phone</option>
                            </select>
                            <i className="fa fa-chevron-down dropdown-icon mt-3"></i>
                          </div>
                        </div>
                        <button type="submit" className="btn btn-danger red_btn mt-4">
                          Save
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSlider;